import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import toast from 'react-hot-toast';

import { resetUser } from '../../Services/Profile';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

function ModalReniciarUsuario({ isOpen, setIsOpen }: Props) {

  const usuarioTestAsesoriaID = JSON.parse( localStorage.getItem("user")!).usuarioTestAsesoriaID;
  const navigate = useNavigate();

  function handleLogout () {
    localStorage.removeItem('user');
    navigate('/login');
  };

  function handleReset () {
    resetUser({
      UsuarioTestAsesoriaID: usuarioTestAsesoriaID
    })
      .then(() => {
        toast.success("El usuario se reinició con éxito!");
      })
      .catch(() => {
        toast.error("Algo salió mal, por favor inténtelo de nuevo");
      })
  }

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle className="text-center">
        ¿Estás seguro de reiniciar tu usuario?
      </DialogTitle>
      <DialogContent>
        <p className='text-center'>
          Perderás todos tus datos llenados y comenzarás de cero. Está opción es definitiva y será por
          única vez.
        </p>
        <div className="flex items-center justify-center gap-5">
          <Button
            variant="contained"
            sx={{
              backgroundColor: '#FF8E01',
              '&:hover': { backgroundColor: '#FF8E01', opacity: '.8' },
            }}
            onClick={() => {
              handleReset();
              handleLogout();
            }}
          >
            Reiniciar
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderColor: '#FF8E01',
              color: 'black',
              '&:hover': { borderColor: '#FF8E01', opacity: '.8' },
            }}
            onClick={() => setIsOpen(false)}
          >
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalReniciarUsuario;
